import { TimelineLite, Elastic } from "gsap"
import { mapMutations } from "vuex"
import formConfig from "../config/formConfig.json"

export default {
  data() {
    return {
      // local object variable to store form data
      formData: {},

      // Reactive object to be used for Provide/Inject
      formState: {
        finalFormData: "",
        activeField: 0,
        isNext: true,
        formLength: this.formFields.length,
        isComplete: false,
        isValid: false,
        isUnderage: false,
        navBackVisible: true,
        navForwardVisible: true,
        navHomeOnlyVisible: false,
        validForRecipe: false,
        hasSymptoms: false,
        hasAnyMedicine: false,
        hasKOAlk: false,
        hasKOHeart: false,
        hasKOStroke: false,
        hasKOLiverKidney: false,
        hasKOBloodPressure: false,
        hasKOAnatomy: false,
        hasKOTvasc: false,
        hasKOMedicine: false,
        hasKOMedicineAdempas: false,
        hasKOMedicineHiv: false,
        hasKOMedicineCancer: false,
        additionalInfo_alt1: "",
        additionalInfo_alt2: "",
        additionalInfo_alt3: "",
        isValidForPsychologicalTreatment: false,
        displayPsychologyTreatmentInfo: false,
        psychologyIsPrimary: false
      }
    }
  },
  computed: {
    activeFieldName() {
      return this.fields[this.formFields[this.formState.activeField].name]
    },
    isCurrentFieldValid() {
      if (this.isNotLastField) {
        return this.activeFieldName && this.activeFieldName.valid
      }
    },
    isNotLastField() {
      return this.formState.activeField < this.formState.formLength
    },
  },
  watch: {
    isNotLastField(newValue) {
      !newValue ? (this.formState.isComplete = true) : (this.formState.isComplete = false)
    },
    isCurrentFieldValid(newValue) {
      newValue ? (this.formState.isValid = true) : (this.formState.isValid = false)
    }
  },
  methods: {
    next() {
      this.formState.isNext = true
      this.isCurrentFieldValid ? this.proceed() : this.decline(".field-area")
    },
    back() {
      this.formState.isNext = false
      this.formState.activeField > 0 ? this.formState.activeField-- : ""
    },
    restart() {
      this.formState.isValidForPsychologicalTreatment = false
      this.formState.displayPsychologyTreatmentInfo = false
      this.formState.psychologyIsPrimary = false
      this.formState.isNext = false
      this.formState.activeField = 0
      this.formData = {}

      const newState = {
        formData: {}
      }
      
      formConfig.forEach(field => {
        newState.formData[field.name] = ""
        this.updateField({ key: field.name, value: "" })
      })

      this.formState.additionalInfo_alt1 = ""
      this.formState.additionalInfo_alt2 = ""
      this.formState.additionalInfo_alt3 = ""
      this.formState.navBackVisible = true
      this.formState.navForwardVisible = true
      this.formState.navHomeOnlyVisible = false

    },
    submit() {
      this.formState.isNext = true
      this.isCurrentFieldValid ? this.proceed() : ""
    },
    proceed() {
      this.isNotLastField ? this.formState.activeField++ : ""

      pushStepEventToDataLayer(this.formState.activeField)

      // Go straight to result page if no symptoms
      if (this.formState.activeField > 0) {
        if (!this.formState.hasSymptoms) {
          this.formState.activeField = this.formState.formLength
          this.formState.navBackVisible = false
          this.formState.navForwardVisible = false
          this.formState.navHomeOnlyVisible = true
        }
      }

      if (this.formState.activeField > 1) {
        if (this.formState.hasKOAlk) {
          this.formState.activeField = this.formState.formLength
          this.formState.navBackVisible = false
          this.formState.navForwardVisible = false
          this.formState.navHomeOnlyVisible = true
        }
      }

      if (this.formState.activeField > 2) {
        if (this.formState.hasKOHeart || this.formState.hasKOStroke) {
          this.formState.activeField = this.formState.formLength
          this.formState.navBackVisible = false
          this.formState.navForwardVisible = false
          this.formState.navHomeOnlyVisible = true
        }
      }

      if (this.formState.activeField > 4) {
        if (this.formState.hasKOLiverKidney || this.formState.hasKOBloodPressure || this.formState.hasKOAnatomy) {
          this.formState.activeField = this.formState.formLength
          this.formState.navBackVisible = false
          this.formState.navForwardVisible = false
          this.formState.navHomeOnlyVisible = true
        }
      }

      if (this.formState.activeField > 5) {
        if (this.formState.hasKOTvasc) {
          this.formState.activeField = this.formState.formLength
          this.formState.navBackVisible = false
          this.formState.navForwardVisible = false
          this.formState.navHomeOnlyVisible = true
        }
      }

      if (this.formState.activeField === 9) {
        if (this.formState.hasAnyMedicine) {
          this.formState.activeField = 9
        } else {
          this.formState.activeField = this.formState.formLength
          this.formState.navBackVisible = false
          this.formState.navForwardVisible = false
          this.formState.navHomeOnlyVisible = true
        }
      }

      if (this.formState.activeField > 9) {
        if (this.formState.hasKOMedicine) {
          this.formState.activeField = this.formState.formLength
          this.formState.navBackVisible = false
          this.formState.navForwardVisible = false
          this.formState.navHomeOnlyVisible = true
        }
      }

      if (this.formState.activeField > 10) {
        if (this.formState.hasKOMedicineAdempas) {
          this.formState.activeField = this.formState.formLength
          this.formState.navBackVisible = false
          this.formState.navForwardVisible = false
          this.formState.navHomeOnlyVisible = true
        }
      }

      if (this.formState.activeField > 11) {
        if (this.formState.hasKOMedicineHiv || this.formState.hasKOMedicineCancer) {
          this.formState.activeField = this.formState.formLength
          this.formState.navBackVisible = false
          this.formState.navForwardVisible = false
          this.formState.navHomeOnlyVisible = true
        }
      }
    },
    decline(element) {
      // Shake form area when the field is invalid
      var tl = new TimelineLite()
      tl.to(element, 0.1, { x: 30 })
      tl.to(element, 3, {
        x: 0,
        color: "#ef6574",
        ease: Elastic.easeOut.config(0.9, 0.1)
      })
    },
    ...mapMutations({
      updateField: "lead/updateField"
    })
  }
}

function pushStepEventToDataLayer(activeField) {
  let eventName = '';

  switch(activeField) {

    case 1:
      eventName = 'step-1-symtom-complete'
      break;
    case 2:
      eventName = 'step-2-livsstil-complete'
      break;
    case 3:
      eventName = 'step-3-sjukdom-complete'
      break;
    case 4:
      eventName = 'step-4-sjukdom-complete'
      break;
    case 5:
      eventName = 'step-5-sjukdom-complete'
      break;
    case 6:
      eventName = 'step-6-kroppen-complete'
      break;
    case 7:
      eventName = 'step-7-kroppen-complete'
      break;
    case 8:
      eventName = 'step-8-ovrigt-complete'
      break;
    case 9:
      eventName = 'step-9-medicin-complete'
      break;
    case 10:
      eventName = 'step-10-medicin-complete'
      break;
    case 11:
      eventName = 'step-11-medicin-complete'
      break;
    case 12:
      eventName = 'step-12-medicin-complete'
      break;
      // code block
  }

  window.dataLayer.push({
    'event': eventName
  });
}
